import type { SxProps, Theme } from '@mui/material/styles';

export const projectionsCardStyles: Record<string, SxProps<Theme>> = {
  root: (theme) => ({
    width: { xs: '100%', sm: 320 },
    backgroundColor: theme.palette.background.default,
    borderRadius: '12px',
    boxShadow: theme.elevations.card,
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  }),
  // Figma: Manrope ExtraBold 16 / 100%, 0 letter-spacing, muted gray (not
  // the same dark color as the headline below it).
  title: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: '1rem',
    lineHeight: 1,
    letterSpacing: 0,
    color: theme.palette.text.secondary,
    margin: 0,
  }),
  // Figma: Manrope ExtraBold 16 / 100%, 0 letter-spacing (uniform across the
  // whole sentence — the highlighted spans differ only in color, not weight).
  headline: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: '1rem',
    lineHeight: 1,
    letterSpacing: 0,
    color: theme.palette.text.primary,
  }),
  // The "no selection yet" placeholder — smaller and regular weight, unlike
  // the real data headline above (which stays ExtraBold per Figma).
  emptyHeadline: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: theme.palette.text.primary,
  }),
  hlPrimary: (theme) => ({ color: theme.palette.primary.main }),
  hlCoral: (theme) => ({ color: theme.palette.secondary.main }),
  // Figma: Manrope ExtraBold 12 / 100%, 0 letter-spacing, centered.
  footnote: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: '0.75rem',
    lineHeight: 1,
    letterSpacing: 0,
    textAlign: 'center',
    color: theme.palette.text.primary,
  }),
  errorText: (theme) => ({
    fontFamily: theme.typography.fontFamily,
    fontSize: '0.9375rem',
    lineHeight: 1.4,
    color: theme.palette.error.main,
  }),
};
